module.exports = __webpack_public_path__ + "static/img/cstSer_bg_04.01db6923.svg";